import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Container from '../Container/Container';
import Header from '../Header/Header';
import Button from '../Button/Button';
import ContainerBG from '../ContainerBG/ContainerBG';

const Arrange = () => {
  const data = useStaticQuery(graphql`
    {
      file(name: { eq: "Realizacje-background" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, quality: 80)
        }
      }
    }
  `);

  return (
    <ContainerBG image={data.file.childImageSharp.gatsbyImageData}>
      <Container height='100vh' fluid flex flexDir='column'>
        <Header
          size='h1'
          Color='#fff'
          style={{ textShadow: '0 0 15px rgba(0, 0, 0, 0.9)' }}>
          Realizacje
        </Header>
        <Button rounded='true' color='#fff' link='/realizacje' arrow='true'>
          więcej
        </Button>
      </Container>
    </ContainerBG>
  );
};

export default Arrange;
